import React from 'react';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

import {
    green500,
    green700,
    greyishBlue500,
    greyishBlue700,
    orange500,
    orange700,
    red500,
    red700
} from "assets/jss/main";

StockTag.propTypes = {
    stock: PropTypes.number
};

function StockTag({stock = 0}) {
    let color;
    let dotColor;

    switch (true) {
        case stock >= 0 && stock <= 5:
            color = red700;
            dotColor = red500;
            break;
        case stock > 5 && stock <= 10:
            color = orange700;
            dotColor = orange500;
            break;
        case stock > 10:
            color = green700;
            dotColor = green500;
            break;
        default:
            color = greyishBlue700;
            dotColor = greyishBlue500;
    }

    return (
        <div style={{
            display: 'flex',
            alignItems: 'center',
            gap: '4px'
        }}>
            <span style={{
                display: 'inline-block',
                width: '6px',
                height: '6px',
                borderRadius: '50%',
                background: dotColor
            }} />
            <span style={{
                color: color,
                fontSize: '11px',
                fontWeight: 500
            }}>
                {stock > 0
                    ? <FormattedMessage id="dashboard.topProducts.mobile.stock.inStock" values={{stock}} />
                    : <FormattedMessage id="dashboard.topProducts.mobile.stock.outOfStock" />}
            </span>
        </div>
    );
}

export default StockTag;
